export default __webpack_public_path__ + "static/backstagesupport-50-b4bdf07c3bacfd1ff14a552595ca85a5.png";